import { useEffect } from 'react';
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import ProblemsSection from './components/ProblemsSection';
import WorkshopSection from './components/WorkshopSection';
import ServicesSection from './components/ServicesSection';
import AboutSection from './components/AboutSection';
import PricingSection from './components/PricingSection';
import OptionsSection from './components/OptionsSection';
import ContactSection from './components/ContactSection';
import SupportAreaSection from './components/SupportAreaSection';
import BusinessBanner from './components/BusinessBanner';
import Footer from './components/Footer';
import { SchemaOrg, getLocalBusinessSchema, getWebPageSchema, getFAQSchema, getServiceSchema } from '../../utils/seo';

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  useEffect(() => {
    // Set page title
    document.title = '松伏町 Web操作サポート ぽかぽか堂 よりみち相談室 | SNS・Canva・公式LINE・ネットショップ運用支援';
    
    // Set meta tags
    const metaTags = [
      { name: 'description', content: 'PC・Web操作が苦手な地元事業者様へ、SNS・Canva・公式LINE・ネットショップなどの実務サポートを丁寧に提供。越谷・松伏エリアの中小企業・個人店向け伴走型サポートサービス。' },
      { name: 'keywords', content: '松伏町,越谷,Web操作サポート,SNS運用,Canva,公式LINE,ネットショップ,中小企業支援,個人事業主,PC操作サポート' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: siteUrl },
      { property: 'og:title', content: '松伏町 Web操作サポート ぽかぽか堂 よりみち相談室' },
      { property: 'og:description', content: 'PC・Web操作が苦手な地元事業者様へ、SNS・Canva・公式LINE・ネットショップなどの実務サポートを丁寧に提供。' },
      { property: 'og:site_name', content: 'ぽかぽか堂 よりみち相談室' },
      { property: 'og:locale', content: 'ja_JP' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: '松伏町 Web操作サポート ぽかぽか堂 よりみち相談室' },
      { name: 'twitter:description', content: 'PC・Web操作が苦手な地元事業者様へ、SNS・Canva・公式LINE・ネットショップなどの実務サポートを丁寧に提供。' }
    ];
    
    metaTags.forEach(({ name, property, content }) => {
      const attr = name ? 'name' : 'property';
      const value = name || property;
      let meta = document.querySelector(`meta[${attr}="${value}"]`);
      
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attr, value);
        document.head.appendChild(meta);
      }
      
      meta.setAttribute('content', content);
    });
    
    // Set canonical link
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', siteUrl);
  }, [siteUrl]);

  return (
    <>
      {/* Schema.org structured data */}
      <SchemaOrg type="LocalBusiness" data={getLocalBusinessSchema()} />
      <SchemaOrg type="WebPage" data={getWebPageSchema()} />
      <SchemaOrg type="FAQPage" data={getFAQSchema()} />
      <SchemaOrg type="Service" data={getServiceSchema()} />

      <div className="min-h-screen bg-gradient-to-b from-green-50 to-white">
        <Navigation />
        <HeroSection />
        <ProblemsSection />
        <WorkshopSection />
        <ServicesSection />
        <AboutSection />
        <PricingSection />
        <OptionsSection />
        <SupportAreaSection />
        <BusinessBanner />
        <ContactSection />
        <Footer />
      </div>
    </>
  );
}
